import styled from 'styled-components';
import Link from '@mui/material/Link';

export const Text = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  margin: 0;
`;

export const GoToLink = styled(Link)`
  color: ${({ theme }) => theme.palette.info.dark};
  font-size: 16px;
  font-weight: 500;
`;

export const EntityName = styled.span`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-weight: 500;
`;
